import {
  SET_DEMO,
  UPDATE_INTAKE_DEMO,
  UPDATE_INTAKE_HISTORY_DEMO,
  UPDATE_TODAYS_INTAKE_DEMO,
} from "../actions/actionTypes";

// Gets the date based on how many days we want to go back since today(the argument)
const getPreviousDate = (pastDay) => {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - pastDay);
  const dd = String(currentDate.getDate()).padStart(2, "0");
  const mm = String(currentDate.getMonth() + 1).padStart(2, "0");
  const yyyy = currentDate.getFullYear();
  return mm + "/" + dd + "/" + yyyy;
};

const initialState = {
  demo: true,
  todays_intake_demo: [
    {
      id: Math.random(),
      name: "Oats",
      amount: 125,
      amountUnit: "g",
      calories: 584,
      fat: 10,
      protein: 25,
      carbs: 95,
    },
    {
      id: Math.random(),
      name: "Blueberries",
      amount: 45,
      amountUnit: "g",
      calories: 26,
      fat: 0,
      protein: 0,
      carbs: 6,
    },
    {
      id: Math.random(),
      name: "Milk",
      amount: 330,
      amountUnit: "ml",
      calories: 186,
      fat: 10,
      protein: 10,
      carbs: 14,
    },
    {
      id: Math.random(),
      name: "Eggs",
      amount: 200,
      amountUnit: "ml",
      calories: 294,
      fat: 20,
      protein: 25,
      carbs: 2,
    },
    {
      id: Math.random(),
      name: "Mushrooms",
      amount: 30,
      amountUnit: "g",
      calories: 7,
      fat: 0,
      protein: 1,
      carbs: 1,
    },
    {
      id: Math.random(),
      name: "Bread",
      amount: 50,
      amountUnit: "g",
      calories: 133,
      fat: 2,
      protein: 4,
      carbs: 25,
    },
    {
      id: Math.random(),
      name: "Chicken Breast",
      amount: 200,
      amountUnit: "g",
      calories: 338,
      fat: 7,
      protein: 62,
      carbs: 0,
    },
    {
      id: Math.random(),
      name: "Rice",
      amount: 100,
      amountUnit: "g",
      calories: 121,
      fat: 0,
      protein: 3,
      carbs: 25,
    },
    {
      id: Math.random(),
      name: "Protein Shake",
      amount: 200,
      amountUnit: "ml",
      calories: 110,
      fat: 0,
      protein: 25,
      carbs: 0,
    },
  ],
  intake_demo: {},
  intake_history_demo: [
    {
      amount: 800,
      calories: 2200,
      carbs: 250,
      date: getPreviousDate(6),
      fat: 35,
      id: 0.272438390505,
      protein: 90,
    },
    {
      amount: 750,
      calories: 2400,
      carbs: 260,
      date: getPreviousDate(5),
      fat: 40,
      id: 0.2341883934,
      protein: 80,
    },
    {
      amount: 900,
      calories: 2000,
      carbs: 240,
      date: getPreviousDate(4),
      fat: 25,
      id: 0.438258390525,
      protein: 75,
    },
    {
      amount: 600,
      calories: 2150,
      carbs: 250,
      date: getPreviousDate(3),
      fat: 30,
      id: 0.118123343551,
      protein: 80,
    },
    {
      amount: 800,
      calories: 2700,
      carbs: 300,
      date: getPreviousDate(2),
      fat: 40,
      id: 0.224135396606,
      protein: 100,
    },
    {
      amount: 700,
      calories: 1800,
      carbs: 245,
      date: getPreviousDate(1),
      fat: 35,
      id: 0.1158393423,
      protein: 95,
    },
    {
      amount: 750,
      calories: 2350,
      carbs: 280,
      date: getPreviousDate(0),
      fat: 25,
      id: 0.23238120552,
      protein: 90,
    },
  ],
};

const demoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DEMO:
      return {
        ...state,
        demo: action.payload,
      };
    case UPDATE_TODAYS_INTAKE_DEMO:
      return {
        ...state,
        todays_intake_demo: action.payload,
      };
    case UPDATE_INTAKE_DEMO:
      return {
        ...state,
        intake_demo: action.payload,
      };
    case UPDATE_INTAKE_HISTORY_DEMO:
      return {
        ...state,
        intake_history_demo: action.payload,
      };
    default:
      return state;
  }
};

export default demoReducer;
